import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import Number from './Number'
import ShortText from './ShortText'
import DropDown from './DropDown'
import DatePickers from './DatePicker'
import SingleChoice from './SingleChoice'
import LongText from './LongText'

const EquipmentCalibrationCheckInForm = () => {


    const  equipmentTypeData = [
        'دماسنج',
        'مانومتر (فشارسنج)',
        'دبی‌سنج (فلومتر)',
        'ترازو',
        'مولتی‌متر',
        'اسیلوسکوپ',
    ]


    const conditionOfEquipmentData =[
        {
            id: 1,
            label: "خوب",
            checked: false
        },
        {
            id: 2,
            label: "نیاز به تعمیر دارد",
            checked: false
        },
        {
            id: 3,
            label: "آسیب دیده",
            checked: false
        },
        {
            id: 4,
            label: "دیگر",
            checked: false
        },
    ]

    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'فرم ثبت کالیبراسیون تجهیزات'} subHeader={'لطفا برای بررسی کالیبراسیون تجهیزات خود، این فرم را پر کنید.'} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <ShortText header={'شناسه تجهیزات'}/>
                <DropDown header={'نوع تجهیزات'} options={equipmentTypeData}/>
                <DatePickers header={'تاریخ ورود'}/>
                <DatePickers header={'آخرین تاریخ کالیبراسیون'}/>
                <DatePickers header={'تاریخ سررسید کالیبراسیون'}/>
                <SingleChoice header={'وضعیت تجهیزات'} options={conditionOfEquipmentData}/>
                <LongText header={'یادداشت‌های تکمیلی'}/>
            </Grid>
        </Grid>
    )
}

export default EquipmentCalibrationCheckInForm
